let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hnVBe")).then(() => parcelRequire('8A2jh'));